import { useMemo } from "react";
import { TextEnum } from "../../text";
import { PrivacyPolicy } from "../../entity";

export const PrivacyPolicyColumns = () => {
  return useMemo(() => {
    return [
      {
        title: TextEnum.VERSION,
        key: TextEnum.VERSION,
        dataIndex: "version",
      },
      {
        title: TextEnum.STATUS,
        key: TextEnum.STATUS,
        render: (text: string, record: PrivacyPolicy) => {
          return record.status === "active"
            ? TextEnum.ACTIVE_PRIVACY_POLICY
            : TextEnum.DRAFT_PRIVACY_POLICY;
        },
      },
      {
        title: TextEnum.CREATED,
        key: TextEnum.CREATED,
        render: (text: string, record: PrivacyPolicy) => {
          return new Date(record.created).toLocaleDateString();
        },
      },
    ];
  }, []);
};
